import "../parts-list/PartsList.css";
import { useEffect, useState } from "react";
import { FaRegCopy } from "react-icons/fa";
import { FaCheck } from "react-icons/fa";

export const PartsListIrrigation = ({
  calculatorDataResult,
  systemType,
  language,
}) => {
  const [formDataResult, setFormDataResult] = useState(null);
  const [copyIcon, setCopyIcon] = useState(<FaRegCopy />);
  const [copyText, setCopyText] = useState("Quantity");

  useEffect(() => {
    setFormDataResult(calculatorDataResult);
  }, [calculatorDataResult]);

  // Limpar o estado local quando o systemType mudar
  useEffect(() => {
    setFormDataResult(null);
  }, [systemType]);

  // Objeto de tradução para os textos em diferentes idiomas
  const languageTexts = {
    "pt-br": {
      title: "Lista de Componentes de Irrigação",
      copyQuantity: "Quantidade",
      copied: "Copiado",
      components: {
        dripper: "Gotejador Autocompensante Netafin",
        blindTube: "Tubo Cego 16mm - metro",
        toothedElbowConnector: "Conector Cotovelo Dentado",
        toothedTConnector: "Conector Tê Dentado",
        finalLineConnectorType8: "Conector de Linha Final Tipo 8",
        toothedUnionConnector: "Conector União Dentado",
        toothedInitialConnector: "Conector Inicial Dentado",
      },
    },
    en: {
      title: "Irrigation Components List",
      copyQuantity: "Quantity",
      copied: "Copied",
      components: {
        dripper: "Self-compensating Dripper Netafin",
        blindTube: "Tube 16mm - meter",
        toothedElbowConnector: "Toothed Elbow Connector",
        toothedTConnector: "Toothed T Connector",
        finalLineConnectorType8: "Type 8 Final Line Connector",
        toothedUnionConnector: "Toothed Union Connector",
        toothedInitialConnector: "Toothed Initial Connector",
      },
    },
    es: {
      title: "Lista de Componentes de Riego",
      copyQuantity: "Cantidad",
      copied: "Copiado",
      components: {
        dripper: "Gotero Autocompensante Netafin",
        blindTube: "Tubo 16mm - metro",
        toothedElbowConnector: "Conector de Rodilla Dentado",
        toothedTConnector: "Conector en T Dentado",
        finalLineConnectorType8: "Conector de Extremo de Tubo Tipo 8",
        toothedUnionConnector: "Conector de Unión Dentado",
        toothedInitialConnector: "Conector Inicial Dentado",
      },
    },
  };

  // Obtém os textos correspondentes à linguagem selecionada
  const texts = languageTexts[language] || languageTexts["pt-br"]; // Se a linguagem não for encontrada, usa o inglês como padrão

  const copyToClipboard = () => {
    const textarea = document.createElement("textarea");
    const quantities = document.querySelectorAll(
      ".quantidade-column-irrigation"
    );

    const quantitiesText = Array.from(quantities)
      .map((quantity) => quantity.textContent)
      .join("\n");

    textarea.value = quantitiesText;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);

    setCopyIcon(<FaCheck />);
    setCopyText(texts.copied);
    setTimeout(() => {
      setCopyIcon(<FaRegCopy />);
      setCopyText(texts.copyQuantity);
    }, 500);

    // Toggle the 'clicked' class for the animation
    const thElement = document.querySelector(".parts-list th");
    thElement.classList.add("clicked");
    setTimeout(() => {
      thElement.classList.remove("clicked");
    }, 500);
  };

  const {
    totalTuboCego,
    totalGotejador,
    totalConectorTe,
    totalFinalDeLinha,
    totalConectorCotovelo,
    totalConectorInicial,
  } = formDataResult ? formDataResult : {};

  return (
    <div className="parts-list container parts-list-irrigation">
      <h2>{texts.title}</h2>
      <table>
        <thead>
          <tr>
            <th>Código</th>
            <th>Item</th>
            <th onClick={copyToClipboard}>
              {texts.copyQuantity} {copyIcon}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>302.001.001</td>
            <td>{texts.components.dripper}</td>
            <td className="quantidade-column-irrigation" id="totalGotejador">
              {totalGotejador}
            </td>
          </tr>
          <tr>
            <td>302.001.003</td>
            <td>{texts.components.blindTube}</td>
            <td className="quantidade-column-irrigation" id="totalTuboCego">
              {totalTuboCego}
            </td>
          </tr>
          <tr>
            <td>302.001.004</td>
            <td>{texts.components.toothedElbowConnector}</td>
            <td
              className="quantidade-column-irrigation"
              id="totalConectorCotovelo"
            >
              {totalConectorCotovelo}
            </td>
          </tr>
          <tr>
            <td>302.001.005</td>
            <td>{texts.components.toothedTConnector}</td>
            <td className="quantidade-column-irrigation" id="totalConectorTe">
              {totalConectorTe}
            </td>
          </tr>
          <tr>
            <td>302.001.006</td>
            <td>{texts.components.finalLineConnectorType8}</td>
            <td className="quantidade-column-irrigation" id="totalFinalDeLinha">
              {totalFinalDeLinha}
            </td>
          </tr>
          <tr>
            <td>302.001.007</td>
            <td>{texts.components.toothedUnionConnector}</td>
            <td
              className="quantidade-column-irrigation"
              id="totalConectorInicial"
            >
              {totalConectorInicial}
            </td>
          </tr>
          <tr>
            <td>302.001.008</td>
            <td>{texts.components.toothedInitialConnector}</td>
            <td
              className="quantidade-column-irrigation"
              id="totalConectorInicial"
            >
              {totalConectorInicial}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
